import './style.css';
import { unref as mn, getCurrentScope as yn, onScopeDispose as En, getCurrentInstance as vn, onMounted as Se, nextTick as Nn, computed as gn, ref as C, watch as Ve, defineComponent as Oe, openBlock as Y, createElementBlock as ae, normalizeClass as Ae, renderSlot as wn, createCommentVNode as ie, pushScopeId as Bt, popScopeId as Ut, createElementVNode as B, Fragment as rt, createBlock as Ne, createVNode as Ft, withCtx as $t, onUnmounted as On, withDirectives as _n, vShow as bn } from "vue";
function qt(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: Vt } = Object.prototype, { getPrototypeOf: it } = Object, ot = ((e) => (t) => {
  const n = Vt.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), ue = (e) => (e = e.toLowerCase(), (t) => ot(t) === e), ke = (e) => (t) => typeof t === e, { isArray: _e } = Array, Ie = ke("undefined");
function In(e) {
  return e !== null && !Ie(e) && e.constructor !== null && !Ie(e.constructor) && me(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const kt = ue("ArrayBuffer");
function Sn(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && kt(e.buffer), t;
}
const Rn = ke("string"), me = ke("function"), jt = ke("number"), st = (e) => e !== null && typeof e == "object", Tn = (e) => e === !0 || e === !1, Pe = (e) => {
  if (ot(e) !== "object")
    return !1;
  const t = it(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, Cn = ue("Date"), An = ue("File"), Pn = ue("Blob"), Mn = ue("FileList"), xn = (e) => st(e) && me(e.pipe), Dn = (e) => {
  const t = "[object FormData]";
  return e && (typeof FormData == "function" && e instanceof FormData || Vt.call(e) === t || me(e.toString) && e.toString() === t);
}, Ln = ue("URLSearchParams"), Bn = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Re(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, i;
  if (typeof e != "object" && (e = [e]), _e(e))
    for (r = 0, i = e.length; r < i; r++)
      t.call(null, e[r], r, e);
  else {
    const o = n ? Object.getOwnPropertyNames(e) : Object.keys(e), s = o.length;
    let c;
    for (r = 0; r < s; r++)
      c = o[r], t.call(null, e[c], c, e);
  }
}
function Yt(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, i;
  for (; r-- > 0; )
    if (i = n[r], t === i.toLowerCase())
      return i;
  return null;
}
const Kt = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), Ht = (e) => !Ie(e) && e !== Kt;
function Xe() {
  const { caseless: e } = Ht(this) && this || {}, t = {}, n = (r, i) => {
    const o = e && Yt(t, i) || i;
    Pe(t[o]) && Pe(r) ? t[o] = Xe(t[o], r) : Pe(r) ? t[o] = Xe({}, r) : _e(r) ? t[o] = r.slice() : t[o] = r;
  };
  for (let r = 0, i = arguments.length; r < i; r++)
    arguments[r] && Re(arguments[r], n);
  return t;
}
const Un = (e, t, n, { allOwnKeys: r } = {}) => (Re(t, (i, o) => {
  n && me(i) ? e[o] = qt(i, n) : e[o] = i;
}, { allOwnKeys: r }), e), Fn = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), $n = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, qn = (e, t, n, r) => {
  let i, o, s;
  const c = {};
  if (t = t || {}, e == null)
    return t;
  do {
    for (i = Object.getOwnPropertyNames(e), o = i.length; o-- > 0; )
      s = i[o], (!r || r(s, e, t)) && !c[s] && (t[s] = e[s], c[s] = !0);
    e = n !== !1 && it(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, Vn = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, kn = (e) => {
  if (!e)
    return null;
  if (_e(e))
    return e;
  let t = e.length;
  if (!jt(t))
    return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, jn = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && it(Uint8Array)), Yn = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let i;
  for (; (i = r.next()) && !i.done; ) {
    const o = i.value;
    t.call(e, o[0], o[1]);
  }
}, Kn = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, Hn = ue("HTMLFormElement"), Gn = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, i) {
    return r.toUpperCase() + i;
  }
), yt = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), zn = ue("RegExp"), Gt = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Re(n, (i, o) => {
    t(i, o, e) !== !1 && (r[o] = i);
  }), Object.defineProperties(e, r);
}, Wn = (e) => {
  Gt(e, (t, n) => {
    if (me(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (me(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, Jn = (e, t) => {
  const n = {}, r = (i) => {
    i.forEach((o) => {
      n[o] = !0;
    });
  };
  return _e(e) ? r(e) : r(String(e).split(t)), n;
}, Xn = () => {
}, Zn = (e, t) => (e = +e, Number.isFinite(e) ? e : t), He = "abcdefghijklmnopqrstuvwxyz", Et = "0123456789", zt = {
  DIGIT: Et,
  ALPHA: He,
  ALPHA_DIGIT: He + He.toUpperCase() + Et
}, Qn = (e = 16, t = zt.ALPHA_DIGIT) => {
  let n = "";
  const { length: r } = t;
  for (; e--; )
    n += t[Math.random() * r | 0];
  return n;
};
function er(e) {
  return !!(e && me(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const tr = (e) => {
  const t = new Array(10), n = (r, i) => {
    if (st(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[i] = r;
        const o = _e(r) ? [] : {};
        return Re(r, (s, c) => {
          const u = n(s, i + 1);
          !Ie(u) && (o[c] = u);
        }), t[i] = void 0, o;
      }
    }
    return r;
  };
  return n(e, 0);
}, a = {
  isArray: _e,
  isArrayBuffer: kt,
  isBuffer: In,
  isFormData: Dn,
  isArrayBufferView: Sn,
  isString: Rn,
  isNumber: jt,
  isBoolean: Tn,
  isObject: st,
  isPlainObject: Pe,
  isUndefined: Ie,
  isDate: Cn,
  isFile: An,
  isBlob: Pn,
  isRegExp: zn,
  isFunction: me,
  isStream: xn,
  isURLSearchParams: Ln,
  isTypedArray: jn,
  isFileList: Mn,
  forEach: Re,
  merge: Xe,
  extend: Un,
  trim: Bn,
  stripBOM: Fn,
  inherits: $n,
  toFlatObject: qn,
  kindOf: ot,
  kindOfTest: ue,
  endsWith: Vn,
  toArray: kn,
  forEachEntry: Yn,
  matchAll: Kn,
  isHTMLForm: Hn,
  hasOwnProperty: yt,
  hasOwnProp: yt,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Gt,
  freezeMethods: Wn,
  toObjectSet: Jn,
  toCamelCase: Gn,
  noop: Xn,
  toFiniteNumber: Zn,
  findKey: Yt,
  global: Kt,
  isContextDefined: Ht,
  ALPHABET: zt,
  generateString: Qn,
  isSpecCompliantForm: er,
  toJSONObject: tr
};
function S(e, t, n, r, i) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i);
}
a.inherits(S, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: a.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const Wt = S.prototype, Jt = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Jt[e] = { value: e };
});
Object.defineProperties(S, Jt);
Object.defineProperty(Wt, "isAxiosError", { value: !0 });
S.from = (e, t, n, r, i, o) => {
  const s = Object.create(Wt);
  return a.toFlatObject(e, s, function(u) {
    return u !== Error.prototype;
  }, (c) => c !== "isAxiosError"), S.call(s, e.message, t, n, r, i), s.cause = e, s.name = e.name, o && Object.assign(s, o), s;
};
const nr = null;
function Ze(e) {
  return a.isPlainObject(e) || a.isArray(e);
}
function Xt(e) {
  return a.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function vt(e, t, n) {
  return e ? e.concat(t).map(function(i, o) {
    return i = Xt(i), !n && o ? "[" + i + "]" : i;
  }).join(n ? "." : "") : t;
}
function rr(e) {
  return a.isArray(e) && !e.some(Ze);
}
const ir = a.toFlatObject(a, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function je(e, t, n) {
  if (!a.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = a.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(N, L) {
    return !a.isUndefined(L[N]);
  });
  const r = n.metaTokens, i = n.visitor || d, o = n.dots, s = n.indexes, u = (n.Blob || typeof Blob < "u" && Blob) && a.isSpecCompliantForm(t);
  if (!a.isFunction(i))
    throw new TypeError("visitor must be a function");
  function l(y) {
    if (y === null)
      return "";
    if (a.isDate(y))
      return y.toISOString();
    if (!u && a.isBlob(y))
      throw new S("Blob is not supported. Use a Buffer instead.");
    return a.isArrayBuffer(y) || a.isTypedArray(y) ? u && typeof Blob == "function" ? new Blob([y]) : Buffer.from(y) : y;
  }
  function d(y, N, L) {
    let h = y;
    if (y && !L && typeof y == "object") {
      if (a.endsWith(N, "{}"))
        N = r ? N : N.slice(0, -2), y = JSON.stringify(y);
      else if (a.isArray(y) && rr(y) || (a.isFileList(y) || a.endsWith(N, "[]")) && (h = a.toArray(y)))
        return N = Xt(N), h.forEach(function(v, I) {
          !(a.isUndefined(v) || v === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            s === !0 ? vt([N], I, o) : s === null ? N : N + "[]",
            l(v)
          );
        }), !1;
    }
    return Ze(y) ? !0 : (t.append(vt(L, N, o), l(y)), !1);
  }
  const f = [], b = Object.assign(ir, {
    defaultVisitor: d,
    convertValue: l,
    isVisitable: Ze
  });
  function _(y, N) {
    if (!a.isUndefined(y)) {
      if (f.indexOf(y) !== -1)
        throw Error("Circular reference detected in " + N.join("."));
      f.push(y), a.forEach(y, function(h, p) {
        (!(a.isUndefined(h) || h === null) && i.call(
          t,
          h,
          a.isString(p) ? p.trim() : p,
          N,
          b
        )) === !0 && _(h, N ? N.concat(p) : [p]);
      }), f.pop();
    }
  }
  if (!a.isObject(e))
    throw new TypeError("data must be an object");
  return _(e), t;
}
function Nt(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function at(e, t) {
  this._pairs = [], e && je(e, this, t);
}
const Zt = at.prototype;
Zt.append = function(t, n) {
  this._pairs.push([t, n]);
};
Zt.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, Nt);
  } : Nt;
  return this._pairs.map(function(i) {
    return n(i[0]) + "=" + n(i[1]);
  }, "").join("&");
};
function or(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Qt(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || or, i = n && n.serialize;
  let o;
  if (i ? o = i(t, n) : o = a.isURLSearchParams(t) ? t.toString() : new at(t, n).toString(r), o) {
    const s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
  }
  return e;
}
class sr {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    a.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const gt = sr, en = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, ar = typeof URLSearchParams < "u" ? URLSearchParams : at, cr = typeof FormData < "u" ? FormData : null, lr = typeof Blob < "u" ? Blob : null, ur = (() => {
  let e;
  return typeof navigator < "u" && ((e = navigator.product) === "ReactNative" || e === "NativeScript" || e === "NS") ? !1 : typeof window < "u" && typeof document < "u";
})(), dr = (() => typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), oe = {
  isBrowser: !0,
  classes: {
    URLSearchParams: ar,
    FormData: cr,
    Blob: lr
  },
  isStandardBrowserEnv: ur,
  isStandardBrowserWebWorkerEnv: dr,
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
function fr(e, t) {
  return je(e, new oe.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, i, o) {
      return oe.isNode && a.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function pr(e) {
  return a.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function hr(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const i = n.length;
  let o;
  for (r = 0; r < i; r++)
    o = n[r], t[o] = e[o];
  return t;
}
function tn(e) {
  function t(n, r, i, o) {
    let s = n[o++];
    const c = Number.isFinite(+s), u = o >= n.length;
    return s = !s && a.isArray(i) ? i.length : s, u ? (a.hasOwnProp(i, s) ? i[s] = [i[s], r] : i[s] = r, !c) : ((!i[s] || !a.isObject(i[s])) && (i[s] = []), t(n, r, i[s], o) && a.isArray(i[s]) && (i[s] = hr(i[s])), !c);
  }
  if (a.isFormData(e) && a.isFunction(e.entries)) {
    const n = {};
    return a.forEachEntry(e, (r, i) => {
      t(pr(r), i, n, 0);
    }), n;
  }
  return null;
}
const mr = {
  "Content-Type": void 0
};
function yr(e, t, n) {
  if (a.isString(e))
    try {
      return (t || JSON.parse)(e), a.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const Ye = {
  transitional: en,
  adapter: ["xhr", "http"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", i = r.indexOf("application/json") > -1, o = a.isObject(t);
    if (o && a.isHTMLForm(t) && (t = new FormData(t)), a.isFormData(t))
      return i && i ? JSON.stringify(tn(t)) : t;
    if (a.isArrayBuffer(t) || a.isBuffer(t) || a.isStream(t) || a.isFile(t) || a.isBlob(t))
      return t;
    if (a.isArrayBufferView(t))
      return t.buffer;
    if (a.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let c;
    if (o) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return fr(t, this.formSerializer).toString();
      if ((c = a.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const u = this.env && this.env.FormData;
        return je(
          c ? { "files[]": t } : t,
          u && new u(),
          this.formSerializer
        );
      }
    }
    return o || i ? (n.setContentType("application/json", !1), yr(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || Ye.transitional, r = n && n.forcedJSONParsing, i = this.responseType === "json";
    if (t && a.isString(t) && (r && !this.responseType || i)) {
      const s = !(n && n.silentJSONParsing) && i;
      try {
        return JSON.parse(t);
      } catch (c) {
        if (s)
          throw c.name === "SyntaxError" ? S.from(c, S.ERR_BAD_RESPONSE, this, null, this.response) : c;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: oe.classes.FormData,
    Blob: oe.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
a.forEach(["delete", "get", "head"], function(t) {
  Ye.headers[t] = {};
});
a.forEach(["post", "put", "patch"], function(t) {
  Ye.headers[t] = a.merge(mr);
});
const ct = Ye, Er = a.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), vr = (e) => {
  const t = {};
  let n, r, i;
  return e && e.split(`
`).forEach(function(s) {
    i = s.indexOf(":"), n = s.substring(0, i).trim().toLowerCase(), r = s.substring(i + 1).trim(), !(!n || t[n] && Er[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, wt = Symbol("internals");
function be(e) {
  return e && String(e).trim().toLowerCase();
}
function Me(e) {
  return e === !1 || e == null ? e : a.isArray(e) ? e.map(Me) : String(e);
}
function Nr(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
function gr(e) {
  return /^[-_a-zA-Z]+$/.test(e.trim());
}
function Ge(e, t, n, r, i) {
  if (a.isFunction(r))
    return r.call(this, t, n);
  if (i && (t = n), !!a.isString(t)) {
    if (a.isString(r))
      return t.indexOf(r) !== -1;
    if (a.isRegExp(r))
      return r.test(t);
  }
}
function wr(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function Or(e, t) {
  const n = a.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(i, o, s) {
        return this[r].call(this, t, i, o, s);
      },
      configurable: !0
    });
  });
}
class Ke {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const i = this;
    function o(c, u, l) {
      const d = be(u);
      if (!d)
        throw new Error("header name must be a non-empty string");
      const f = a.findKey(i, d);
      (!f || i[f] === void 0 || l === !0 || l === void 0 && i[f] !== !1) && (i[f || u] = Me(c));
    }
    const s = (c, u) => a.forEach(c, (l, d) => o(l, d, u));
    return a.isPlainObject(t) || t instanceof this.constructor ? s(t, n) : a.isString(t) && (t = t.trim()) && !gr(t) ? s(vr(t), n) : t != null && o(n, t, r), this;
  }
  get(t, n) {
    if (t = be(t), t) {
      const r = a.findKey(this, t);
      if (r) {
        const i = this[r];
        if (!n)
          return i;
        if (n === !0)
          return Nr(i);
        if (a.isFunction(n))
          return n.call(this, i, r);
        if (a.isRegExp(n))
          return n.exec(i);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = be(t), t) {
      const r = a.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Ge(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let i = !1;
    function o(s) {
      if (s = be(s), s) {
        const c = a.findKey(r, s);
        c && (!n || Ge(r, r[c], c, n)) && (delete r[c], i = !0);
      }
    }
    return a.isArray(t) ? t.forEach(o) : o(t), i;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, i = !1;
    for (; r--; ) {
      const o = n[r];
      (!t || Ge(this, this[o], o, t, !0)) && (delete this[o], i = !0);
    }
    return i;
  }
  normalize(t) {
    const n = this, r = {};
    return a.forEach(this, (i, o) => {
      const s = a.findKey(r, o);
      if (s) {
        n[s] = Me(i), delete n[o];
        return;
      }
      const c = t ? wr(o) : String(o).trim();
      c !== o && delete n[o], n[c] = Me(i), r[c] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return a.forEach(this, (r, i) => {
      r != null && r !== !1 && (n[i] = t && a.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((i) => r.set(i)), r;
  }
  static accessor(t) {
    const r = (this[wt] = this[wt] = {
      accessors: {}
    }).accessors, i = this.prototype;
    function o(s) {
      const c = be(s);
      r[c] || (Or(i, s), r[c] = !0);
    }
    return a.isArray(t) ? t.forEach(o) : o(t), this;
  }
}
Ke.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
a.freezeMethods(Ke.prototype);
a.freezeMethods(Ke);
const le = Ke;
function ze(e, t) {
  const n = this || ct, r = t || n, i = le.from(r.headers);
  let o = r.data;
  return a.forEach(e, function(c) {
    o = c.call(n, o, i.normalize(), t ? t.status : void 0);
  }), i.normalize(), o;
}
function nn(e) {
  return !!(e && e.__CANCEL__);
}
function Te(e, t, n) {
  S.call(this, e ?? "canceled", S.ERR_CANCELED, t, n), this.name = "CanceledError";
}
a.inherits(Te, S, {
  __CANCEL__: !0
});
function _r(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new S(
    "Request failed with status code " + n.status,
    [S.ERR_BAD_REQUEST, S.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
const br = oe.isStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  function() {
    return {
      write: function(n, r, i, o, s, c) {
        const u = [];
        u.push(n + "=" + encodeURIComponent(r)), a.isNumber(i) && u.push("expires=" + new Date(i).toGMTString()), a.isString(o) && u.push("path=" + o), a.isString(s) && u.push("domain=" + s), c === !0 && u.push("secure"), document.cookie = u.join("; ");
      },
      read: function(n) {
        const r = document.cookie.match(new RegExp("(^|;\\s*)(" + n + ")=([^;]*)"));
        return r ? decodeURIComponent(r[3]) : null;
      },
      remove: function(n) {
        this.write(n, "", Date.now() - 864e5);
      }
    };
  }()
) : (
  // Non standard browser env (web workers, react-native) lack needed support.
  function() {
    return {
      write: function() {
      },
      read: function() {
        return null;
      },
      remove: function() {
      }
    };
  }()
);
function Ir(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Sr(e, t) {
  return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function rn(e, t) {
  return e && !Ir(t) ? Sr(e, t) : t;
}
const Rr = oe.isStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const t = /(msie|trident)/i.test(navigator.userAgent), n = document.createElement("a");
    let r;
    function i(o) {
      let s = o;
      return t && (n.setAttribute("href", s), s = n.href), n.setAttribute("href", s), {
        href: n.href,
        protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
        host: n.host,
        search: n.search ? n.search.replace(/^\?/, "") : "",
        hash: n.hash ? n.hash.replace(/^#/, "") : "",
        hostname: n.hostname,
        port: n.port,
        pathname: n.pathname.charAt(0) === "/" ? n.pathname : "/" + n.pathname
      };
    }
    return r = i(window.location.href), function(s) {
      const c = a.isString(s) ? i(s) : s;
      return c.protocol === r.protocol && c.host === r.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  function() {
    return function() {
      return !0;
    };
  }()
);
function Tr(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function Cr(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let i = 0, o = 0, s;
  return t = t !== void 0 ? t : 1e3, function(u) {
    const l = Date.now(), d = r[o];
    s || (s = l), n[i] = u, r[i] = l;
    let f = o, b = 0;
    for (; f !== i; )
      b += n[f++], f = f % e;
    if (i = (i + 1) % e, i === o && (o = (o + 1) % e), l - s < t)
      return;
    const _ = d && l - d;
    return _ ? Math.round(b * 1e3 / _) : void 0;
  };
}
function Ot(e, t) {
  let n = 0;
  const r = Cr(50, 250);
  return (i) => {
    const o = i.loaded, s = i.lengthComputable ? i.total : void 0, c = o - n, u = r(c), l = o <= s;
    n = o;
    const d = {
      loaded: o,
      total: s,
      progress: s ? o / s : void 0,
      bytes: c,
      rate: u || void 0,
      estimated: u && s && l ? (s - o) / u : void 0,
      event: i
    };
    d[t ? "download" : "upload"] = !0, e(d);
  };
}
const Ar = typeof XMLHttpRequest < "u", Pr = Ar && function(e) {
  return new Promise(function(n, r) {
    let i = e.data;
    const o = le.from(e.headers).normalize(), s = e.responseType;
    let c;
    function u() {
      e.cancelToken && e.cancelToken.unsubscribe(c), e.signal && e.signal.removeEventListener("abort", c);
    }
    a.isFormData(i) && (oe.isStandardBrowserEnv || oe.isStandardBrowserWebWorkerEnv) && o.setContentType(!1);
    let l = new XMLHttpRequest();
    if (e.auth) {
      const _ = e.auth.username || "", y = e.auth.password ? unescape(encodeURIComponent(e.auth.password)) : "";
      o.set("Authorization", "Basic " + btoa(_ + ":" + y));
    }
    const d = rn(e.baseURL, e.url);
    l.open(e.method.toUpperCase(), Qt(d, e.params, e.paramsSerializer), !0), l.timeout = e.timeout;
    function f() {
      if (!l)
        return;
      const _ = le.from(
        "getAllResponseHeaders" in l && l.getAllResponseHeaders()
      ), N = {
        data: !s || s === "text" || s === "json" ? l.responseText : l.response,
        status: l.status,
        statusText: l.statusText,
        headers: _,
        config: e,
        request: l
      };
      _r(function(h) {
        n(h), u();
      }, function(h) {
        r(h), u();
      }, N), l = null;
    }
    if ("onloadend" in l ? l.onloadend = f : l.onreadystatechange = function() {
      !l || l.readyState !== 4 || l.status === 0 && !(l.responseURL && l.responseURL.indexOf("file:") === 0) || setTimeout(f);
    }, l.onabort = function() {
      l && (r(new S("Request aborted", S.ECONNABORTED, e, l)), l = null);
    }, l.onerror = function() {
      r(new S("Network Error", S.ERR_NETWORK, e, l)), l = null;
    }, l.ontimeout = function() {
      let y = e.timeout ? "timeout of " + e.timeout + "ms exceeded" : "timeout exceeded";
      const N = e.transitional || en;
      e.timeoutErrorMessage && (y = e.timeoutErrorMessage), r(new S(
        y,
        N.clarifyTimeoutError ? S.ETIMEDOUT : S.ECONNABORTED,
        e,
        l
      )), l = null;
    }, oe.isStandardBrowserEnv) {
      const _ = (e.withCredentials || Rr(d)) && e.xsrfCookieName && br.read(e.xsrfCookieName);
      _ && o.set(e.xsrfHeaderName, _);
    }
    i === void 0 && o.setContentType(null), "setRequestHeader" in l && a.forEach(o.toJSON(), function(y, N) {
      l.setRequestHeader(N, y);
    }), a.isUndefined(e.withCredentials) || (l.withCredentials = !!e.withCredentials), s && s !== "json" && (l.responseType = e.responseType), typeof e.onDownloadProgress == "function" && l.addEventListener("progress", Ot(e.onDownloadProgress, !0)), typeof e.onUploadProgress == "function" && l.upload && l.upload.addEventListener("progress", Ot(e.onUploadProgress)), (e.cancelToken || e.signal) && (c = (_) => {
      l && (r(!_ || _.type ? new Te(null, e, l) : _), l.abort(), l = null);
    }, e.cancelToken && e.cancelToken.subscribe(c), e.signal && (e.signal.aborted ? c() : e.signal.addEventListener("abort", c)));
    const b = Tr(d);
    if (b && oe.protocols.indexOf(b) === -1) {
      r(new S("Unsupported protocol " + b + ":", S.ERR_BAD_REQUEST, e));
      return;
    }
    l.send(i || null);
  });
}, xe = {
  http: nr,
  xhr: Pr
};
a.forEach(xe, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Mr = {
  getAdapter: (e) => {
    e = a.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    for (let i = 0; i < t && (n = e[i], !(r = a.isString(n) ? xe[n.toLowerCase()] : n)); i++)
      ;
    if (!r)
      throw r === !1 ? new S(
        `Adapter ${n} is not supported by the environment`,
        "ERR_NOT_SUPPORT"
      ) : new Error(
        a.hasOwnProp(xe, n) ? `Adapter '${n}' is not available in the build` : `Unknown adapter '${n}'`
      );
    if (!a.isFunction(r))
      throw new TypeError("adapter is not a function");
    return r;
  },
  adapters: xe
};
function We(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Te(null, e);
}
function _t(e) {
  return We(e), e.headers = le.from(e.headers), e.data = ze.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Mr.getAdapter(e.adapter || ct.adapter)(e).then(function(r) {
    return We(e), r.data = ze.call(
      e,
      e.transformResponse,
      r
    ), r.headers = le.from(r.headers), r;
  }, function(r) {
    return nn(r) || (We(e), r && r.response && (r.response.data = ze.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = le.from(r.response.headers))), Promise.reject(r);
  });
}
const bt = (e) => e instanceof le ? e.toJSON() : e;
function we(e, t) {
  t = t || {};
  const n = {};
  function r(l, d, f) {
    return a.isPlainObject(l) && a.isPlainObject(d) ? a.merge.call({ caseless: f }, l, d) : a.isPlainObject(d) ? a.merge({}, d) : a.isArray(d) ? d.slice() : d;
  }
  function i(l, d, f) {
    if (a.isUndefined(d)) {
      if (!a.isUndefined(l))
        return r(void 0, l, f);
    } else
      return r(l, d, f);
  }
  function o(l, d) {
    if (!a.isUndefined(d))
      return r(void 0, d);
  }
  function s(l, d) {
    if (a.isUndefined(d)) {
      if (!a.isUndefined(l))
        return r(void 0, l);
    } else
      return r(void 0, d);
  }
  function c(l, d, f) {
    if (f in t)
      return r(l, d);
    if (f in e)
      return r(void 0, l);
  }
  const u = {
    url: o,
    method: o,
    data: o,
    baseURL: s,
    transformRequest: s,
    transformResponse: s,
    paramsSerializer: s,
    timeout: s,
    timeoutMessage: s,
    withCredentials: s,
    adapter: s,
    responseType: s,
    xsrfCookieName: s,
    xsrfHeaderName: s,
    onUploadProgress: s,
    onDownloadProgress: s,
    decompress: s,
    maxContentLength: s,
    maxBodyLength: s,
    beforeRedirect: s,
    transport: s,
    httpAgent: s,
    httpsAgent: s,
    cancelToken: s,
    socketPath: s,
    responseEncoding: s,
    validateStatus: c,
    headers: (l, d) => i(bt(l), bt(d), !0)
  };
  return a.forEach(Object.keys(e).concat(Object.keys(t)), function(d) {
    const f = u[d] || i, b = f(e[d], t[d], d);
    a.isUndefined(b) && f !== c || (n[d] = b);
  }), n;
}
const on = "1.3.4", lt = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  lt[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const It = {};
lt.transitional = function(t, n, r) {
  function i(o, s) {
    return "[Axios v" + on + "] Transitional option '" + o + "'" + s + (r ? ". " + r : "");
  }
  return (o, s, c) => {
    if (t === !1)
      throw new S(
        i(s, " has been removed" + (n ? " in " + n : "")),
        S.ERR_DEPRECATED
      );
    return n && !It[s] && (It[s] = !0, console.warn(
      i(
        s,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(o, s, c) : !0;
  };
};
function xr(e, t, n) {
  if (typeof e != "object")
    throw new S("options must be an object", S.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let i = r.length;
  for (; i-- > 0; ) {
    const o = r[i], s = t[o];
    if (s) {
      const c = e[o], u = c === void 0 || s(c, o, e);
      if (u !== !0)
        throw new S("option " + o + " must be " + u, S.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new S("Unknown option " + o, S.ERR_BAD_OPTION);
  }
}
const Qe = {
  assertOptions: xr,
  validators: lt
}, pe = Qe.validators;
class $e {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new gt(),
      response: new gt()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = we(this.defaults, n);
    const { transitional: r, paramsSerializer: i, headers: o } = n;
    r !== void 0 && Qe.assertOptions(r, {
      silentJSONParsing: pe.transitional(pe.boolean),
      forcedJSONParsing: pe.transitional(pe.boolean),
      clarifyTimeoutError: pe.transitional(pe.boolean)
    }, !1), i !== void 0 && Qe.assertOptions(i, {
      encode: pe.function,
      serialize: pe.function
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let s;
    s = o && a.merge(
      o.common,
      o[n.method]
    ), s && a.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (y) => {
        delete o[y];
      }
    ), n.headers = le.concat(s, o);
    const c = [];
    let u = !0;
    this.interceptors.request.forEach(function(N) {
      typeof N.runWhen == "function" && N.runWhen(n) === !1 || (u = u && N.synchronous, c.unshift(N.fulfilled, N.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(N) {
      l.push(N.fulfilled, N.rejected);
    });
    let d, f = 0, b;
    if (!u) {
      const y = [_t.bind(this), void 0];
      for (y.unshift.apply(y, c), y.push.apply(y, l), b = y.length, d = Promise.resolve(n); f < b; )
        d = d.then(y[f++], y[f++]);
      return d;
    }
    b = c.length;
    let _ = n;
    for (f = 0; f < b; ) {
      const y = c[f++], N = c[f++];
      try {
        _ = y(_);
      } catch (L) {
        N.call(this, L);
        break;
      }
    }
    try {
      d = _t.call(this, _);
    } catch (y) {
      return Promise.reject(y);
    }
    for (f = 0, b = l.length; f < b; )
      d = d.then(l[f++], l[f++]);
    return d;
  }
  getUri(t) {
    t = we(this.defaults, t);
    const n = rn(t.baseURL, t.url);
    return Qt(n, t.params, t.paramsSerializer);
  }
}
a.forEach(["delete", "get", "head", "options"], function(t) {
  $e.prototype[t] = function(n, r) {
    return this.request(we(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
a.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(o, s, c) {
      return this.request(we(c || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: s
      }));
    };
  }
  $e.prototype[t] = n(), $e.prototype[t + "Form"] = n(!0);
});
const De = $e;
class ut {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(o) {
      n = o;
    });
    const r = this;
    this.promise.then((i) => {
      if (!r._listeners)
        return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](i);
      r._listeners = null;
    }), this.promise.then = (i) => {
      let o;
      const s = new Promise((c) => {
        r.subscribe(c), o = c;
      }).then(i);
      return s.cancel = function() {
        r.unsubscribe(o);
      }, s;
    }, t(function(o, s, c) {
      r.reason || (r.reason = new Te(o, s, c), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new ut(function(i) {
        t = i;
      }),
      cancel: t
    };
  }
}
const Dr = ut;
function Lr(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function Br(e) {
  return a.isObject(e) && e.isAxiosError === !0;
}
const et = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(et).forEach(([e, t]) => {
  et[t] = e;
});
const Ur = et;
function sn(e) {
  const t = new De(e), n = qt(De.prototype.request, t);
  return a.extend(n, De.prototype, t, { allOwnKeys: !0 }), a.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(i) {
    return sn(we(e, i));
  }, n;
}
const U = sn(ct);
U.Axios = De;
U.CanceledError = Te;
U.CancelToken = Dr;
U.isCancel = nn;
U.VERSION = on;
U.toFormData = je;
U.AxiosError = S;
U.Cancel = U.CanceledError;
U.all = function(t) {
  return Promise.all(t);
};
U.spread = Lr;
U.isAxiosError = Br;
U.mergeConfig = we;
U.AxiosHeaders = le;
U.formToJSON = (e) => tn(a.isHTMLForm(e) ? new FormData(e) : e);
U.HttpStatusCode = Ur;
U.default = U;
const ce = U, z = {
  DEVELOPMENT: "development",
  STAGING: "staging",
  SANDBOX: "sandbox",
  PRODUCTION: "production"
}, q = {
  STRIPE: "stripe",
  AUTHORIZE_NET: "authorize-net",
  NMI: "nmi"
}, Ee = {
  [z.SANDBOX]: "https://jstest.authorize.net/v1/Accept.js",
  [z.PRODUCTION]: "https://js.authorize.net/v1/Accept.js"
}, ve = {
  [z.SANDBOX]: "https://secure.safewebservices.com/token/Collect.js",
  [z.PRODUCTION]: "https://secure.safewebservices.com/token/Collect.js"
}, ge = {
  [z.DEVELOPMENT]: "http://localhost:5055/payments",
  [z.STAGING]: "https://staging.services.leadconnectorhq.com/payments",
  [z.PRODUCTION]: "https://services.leadconnectorhq.com/payments"
}, dt = {
  [z.DEVELOPMENT]: "http://localhost:5075/invoices",
  [z.STAGING]: "https://staging.services.leadconnectorhq.com/invoices",
  [z.PRODUCTION]: "https://services.leadconnectorhq.com/invoices"
}, he = {
  ORDER: "order",
  INVOICE: "invoice"
}, Z = {
  READY: "ready",
  PROCESSING: "processing",
  ERROR: "error",
  SUCCESS: "success"
}, $ = {
  PAYMENT_CALLBACK: "payment-callback"
}, Fr = {
  VALIDATION_ERROR: "validation_error"
}, St = {
  SERVER_ERROR: "server_error"
}, M = {
  INVALID_PAYMENT_SOURCE: "Invalid source!",
  STRIPE_SDK_LOAD_ERROR: "Could not load Stripe.js",
  STRIPE_PAYMENT_ELEMENT_CREATE_ERROR: "Could not create payment element",
  SOMETHING_WENT_WRONG_IN_INITIATE_PAYMENT: "Something went wrong in initiate payment!",
  SOMETHING_WENT_WRONG_IN_CONFIRMING_PAYMENT: "Something went wrong in confirming payment!",
  FAILED_TO_CONFIRM_PAYMENT: "Failed to confirm payment!",
  PLACE_NEW_ORDER: "Please place a new order!",
  SOMETHING_WENT_WRONG_IN_FETCHING_ORDER: "Something went wrong in fetching order details",
  SOMETHING_WENT_WRONG_IN_FETCHING_PAYMENT_INTEGRATIONS: "Something went wrong in fetching payment integrations",
  PAYMENT_PROVIDER_NOT_FOUND: "No payment provider found",
  INVALID_PAYMENT_PROVIDER: "Invalid payment provider",
  STRIPE_CONNECTION_NOT_FOUND: "No stripe connection details found",
  NMI_CONNECTION_NOT_FOUND: "No NMI connection details found",
  AUTHORIZE_NET_CONNECTION_NOT_FOUND: "No authorize.net connection details found",
  NMI_SDK_LOAD_ERROR: "Something went wrong!! This could be due to an invalid or incomplete field or poor connectivity",
  INVALID_CARD_DETAILS: "Invalid card details",
  SOMETHING_WENT_WRONG: "Something went wrong!",
  CARD_EXPIRY_YEAR_IN_PAST: "Your card's expiration year is in the past.",
  INVALID_CARD_EXPIRY_YEAR: "Your card's expiration year is invalid.",
  CARD_EXPIRY_MONTH_IN_PAST: "Your card's expiration month is in the past",
  SOMETHING_WENT_WRONG_IN_GETTING_CARD_TOKEN: "Something went wrong in getting card token data!",
  SOMETHING_WENT_WRONG_IN_FETCHING_INVOICE: "Something went wrong in fetching invoice details",
  STRIPE_PAYMENT_ELEMENT_LOAD_ERROR: "No valid payment method available. Please contact business owner"
}, an = (e, t, n, r) => {
  let i = document.getElementById(e);
  return i || (i = document.createElement("script"), i.setAttribute("id", e), i.src = t, n === "nmi" ? i.setAttribute("data-tokenization-key", r) : n === "authorize-net" && i.setAttribute("charset", "utf-8"), document.head.appendChild(i)), i;
}, $r = (e) => ({
  variant: "inline",
  styleSniffer: !0,
  invalidCss: {
    color: "#B40E3E"
  },
  customCss: {
    "border-color": "rgb(209, 213, 219)",
    "border-style": "solid",
    "border-width": "1px",
    "border-radius": "5px",
    "line-height": "24px",
    padding: "8px 12px",
    "font-size": "12px",
    height: "40px",
    "font-family": "sans-serif"
  },
  focusCss: {
    "border-color": "rgb(1, 125, 233)",
    "border-style": "solid",
    "border-width": "1px"
  },
  fields: {
    ccnumber: {
      title: "Card Number",
      placeholder: "1234 1234 1234 1234",
      selector: `#ccnumber-${e}`
    },
    ccexp: {
      placeholder: "MM / YY",
      selector: `#ccexp-${e}`
    },
    cvv: {
      placeholder: "CVV",
      selector: `#cvv-${e}`
    }
  }
}), qe = (e) => {
  var n, r;
  let t = (r = (n = e == null ? void 0 : e.response) == null ? void 0 : n.data) == null ? void 0 : r.message;
  return Array.isArray(t) && (t = t.join(", ")), t != null && t.includes("FDS") && (t = "Your transaction has been declined. Please contact the business owner"), t;
};
var Rt;
const cn = typeof window < "u";
cn && ((Rt = window == null ? void 0 : window.navigator) != null && Rt.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function qr(e) {
  return typeof e == "function" ? e() : mn(e);
}
function Vr(e) {
  return e;
}
function kr(e) {
  return yn() ? (En(e), !0) : !1;
}
function jr(e, t = !0) {
  vn() ? Se(e) : t ? e() : Nn(e);
}
function Le(e) {
  var t;
  const n = qr(e);
  return (t = n == null ? void 0 : n.$el) != null ? t : n;
}
const ln = cn ? window : void 0;
function Yr(e, t = !1) {
  const n = C(), r = () => n.value = !!e();
  return r(), jr(r, t), n;
}
const Tt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ct = "__vueuse_ssr_handlers__";
Tt[Ct] = Tt[Ct] || {};
var At = Object.getOwnPropertySymbols, Kr = Object.prototype.hasOwnProperty, Hr = Object.prototype.propertyIsEnumerable, Gr = (e, t) => {
  var n = {};
  for (var r in e)
    Kr.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && At)
    for (var r of At(e))
      t.indexOf(r) < 0 && Hr.call(e, r) && (n[r] = e[r]);
  return n;
};
function zr(e, t, n = {}) {
  const r = n, { window: i = ln } = r, o = Gr(r, ["window"]);
  let s;
  const c = Yr(() => i && "ResizeObserver" in i), u = () => {
    s && (s.disconnect(), s = void 0);
  }, l = Ve(() => Le(e), (f) => {
    u(), c.value && i && f && (s = new ResizeObserver(t), s.observe(f, o));
  }, { immediate: !0, flush: "post" }), d = () => {
    u(), l();
  };
  return kr(d), {
    isSupported: c,
    stop: d
  };
}
function Wr(e, t = { width: 0, height: 0 }, n = {}) {
  const { window: r = ln, box: i = "content-box" } = n, o = gn(() => {
    var u, l;
    return (l = (u = Le(e)) == null ? void 0 : u.namespaceURI) == null ? void 0 : l.includes("svg");
  }), s = C(t.width), c = C(t.height);
  return zr(e, ([u]) => {
    const l = i === "border-box" ? u.borderBoxSize : i === "content-box" ? u.contentBoxSize : u.devicePixelContentBoxSize;
    if (r && o.value) {
      const d = Le(e);
      if (d) {
        const f = r.getComputedStyle(d);
        s.value = parseFloat(f.width), c.value = parseFloat(f.height);
      }
    } else if (l) {
      const d = Array.isArray(l) ? l : [l];
      s.value = d.reduce((f, { inlineSize: b }) => f + b, 0), c.value = d.reduce((f, { blockSize: b }) => f + b, 0);
    } else
      s.value = u.contentRect.width, c.value = u.contentRect.height;
  }, n), Ve(() => Le(e), (u) => {
    s.value = u ? t.width : 0, c.value = u ? t.height : 0;
  }), {
    width: s,
    height: c
  };
}
var Pt;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(Pt || (Pt = {}));
var Jr = Object.defineProperty, Mt = Object.getOwnPropertySymbols, Xr = Object.prototype.hasOwnProperty, Zr = Object.prototype.propertyIsEnumerable, xt = (e, t, n) => t in e ? Jr(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Qr = (e, t) => {
  for (var n in t || (t = {}))
    Xr.call(t, n) && xt(e, n, t[n]);
  if (Mt)
    for (var n of Mt(t))
      Zr.call(t, n) && xt(e, n, t[n]);
  return e;
};
const ei = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
Qr({
  linear: Vr
}, ei);
const un = /* @__PURE__ */ Oe({
  __name: "CreditCardContainer",
  setup(e) {
    const t = C(null), n = C("credit-card-container"), { width: r } = Wr(
      t
    );
    return Ve(r, () => {
      r.value < 470 ? n.value = "credit-card-container" : n.value = "inline-credit-card-container";
    }), (i, o) => (Y(), ae("div", {
      ref_key: "creditCardContainerEl",
      ref: t,
      class: Ae(n.value)
    }, [
      wn(i.$slots, "default")
    ], 2));
  }
}), ti = (e) => (Bt("data-v-2ac2b44d"), e = e(), Ut(), e), ni = {
  key: 0,
  class: "payment-mode-container"
}, ri = /* @__PURE__ */ ti(() => /* @__PURE__ */ B("span", { class: "test-mode-badge" }, "Test Mode", -1)), ii = [
  ri
], oi = /* @__PURE__ */ Oe({
  __name: "TestModeBadge",
  props: {
    liveMode: { type: Boolean }
  },
  setup(e) {
    return (t, n) => e.liveMode === !1 ? (Y(), ae("div", ni, ii)) : ie("", !0);
  }
});
const dn = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, ft = /* @__PURE__ */ dn(oi, [["__scopeId", "data-v-2ac2b44d"]]), pt = (e) => (Bt("data-v-b2d1e265"), e = e(), Ut(), e), si = /* @__PURE__ */ pt(() => /* @__PURE__ */ B("label", {
  for: "cardNumber",
  class: "card-input-label"
}, "Card Number", -1)), ai = ["value", "disabled", "id", "maxlength"], ci = { class: "credit-card-sub-container" }, li = /* @__PURE__ */ pt(() => /* @__PURE__ */ B("label", {
  for: "cardExpiration",
  class: "card-input-label"
}, "Expiration", -1)), ui = ["value", "disabled", "id"], di = /* @__PURE__ */ pt(() => /* @__PURE__ */ B("label", {
  for: "cardExpiration",
  class: "card-input-label"
}, "CVC", -1)), fi = ["value", "disabled", "id", "maxlength"], pi = {
  name: "UIAuthorizeNetCardElement",
  inheritAttrs: !1
}, hi = /* @__PURE__ */ Oe({
  ...pi,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    merchantPublicClientKey: {
      type: String,
      required: !0
    },
    merchantLoginId: {
      type: String,
      required: !0
    }
  },
  emits: [$.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = C(!0), o = C(!1), s = C(!1), c = C(!1), u = C(!1), l = C(!1), d = C(!1), f = C(), b = C(!1), _ = C(), y = C(!1), N = C(), L = C(!1), h = C(), p = (E) => b.value = E, v = (E) => y.value = E, I = (E) => L.value = E, A = (E) => {
      n($.PAYMENT_CALLBACK, {
        type: Z.ERROR,
        message: E,
        provider: q.AUTHORIZE_NET
      });
    }, j = () => {
      p(!1), v(!1), I(!1), A("");
    };
    Se(() => m());
    async function m() {
      const { liveMode: E } = r, w = E ? Ee == null ? void 0 : Ee[z.PRODUCTION] : Ee == null ? void 0 : Ee[z.SANDBOX];
      i.value = !0, await an(
        "accept-js",
        w,
        q.AUTHORIZE_NET
      ), n($.PAYMENT_CALLBACK, {
        type: Z.READY,
        value: !0,
        provider: q.AUTHORIZE_NET
      }), i.value = !1;
    }
    const g = (E) => {
      var w;
      O((w = E == null ? void 0 : E.target) == null ? void 0 : w.value);
    }, O = (E) => {
      p(!1);
      const w = E.replace(/\D/g, "");
      return o.value = !1, s.value = !1, d.value = !1, c.value = !1, u.value = !1, l.value = !1, /^3[47]\d{0,13}$/.test(w) ? (o.value = !0, h.value = 17, f.value = w.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(w) ? (s.value = !0, h.value = 16, f.value = w.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^4[0]\d{0,11}$/.test(w) ? (c.value = !0, h.value = 19, f.value = w.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{5})/, "$1 $2 ")) : /^5[12345]\d{0,13}$/.test(w) ? (d.value = !0, h.value = 19, f.value = E.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")) : /^5\d{0,14}$/.test(w) ? (u.value = !0, h.value = 17, f.value = w.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^6011\d{0,12}$/.test(w) || /^5\d{0,14}$/.test(w) ? (u.value = !0, h.value = 18, f.value = w.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : /^2131|1800\d{11}$/.test(w) ? (l.value = !0, h.value = 17, f.value = w.replace(/(\d{4})/, "$1 ").replace(/(\d{4}) (\d{6})/, "$1 $2 ")) : (h.value = 19, d.value = !0, f.value = E.replace(/\W/gi, "").replace(/(.{4})/g, "$1 ")), f.value = f.value.replace(/\s*$/, ""), isNaN(Number(f.value.replace(/\s/g, ""))) && p(!0), f.value;
    }, P = (E) => {
      var w, T, D, H, x;
      if (f.value = E.target.value, !f.value) {
        p(!0);
        return;
      }
      if (isNaN(Number(f.value.replace(/\s/g, ""))))
        return p(!0);
      c.value && f.value.length < 15 || (o.value || u.value) && ((w = f.value) == null ? void 0 : w.length) < 17 || s.value && ((T = f.value) == null ? void 0 : T.length) < 16 || d.value && ((D = f.value) == null ? void 0 : D.length) < 19 ? p(!0) : p(!1), o.value && ((H = N.value) == null ? void 0 : H.length) < 4 || !o.value && ((x = N.value) == null ? void 0 : x.length) < 3 ? I(!0) : I(!1);
    }, R = (E) => {
      const w = E.which || E.keyCode;
      if (w !== 8 && w !== 9 && w !== 91 && w !== 65 && w !== 86 && w !== 37 && w !== 38 && w !== 39 && w !== 40 && isNaN(Number(E.key))) {
        E.preventDefault();
        return;
      }
      return !0;
    }, F = (E) => {
      E.target.value.length > 5 || (v(!1), _.value = E.target.value.replace(
        /^([1-9]\/|[2-9])$/g,
        "0$1 /"
        // 3 > 03/
      ).replace(
        /^(0[1-9]|1[0-2])$/g,
        "$1/"
        // 11 > 11/
      ).replace(
        /^([0-1])([3-9])$/g,
        "0$1/$2"
        // 13 > 01/3
      ).replace(
        /^(0?[1-9]|1[0-2])([0-9]{2})$/g,
        "$1/$2"
        // 141 > 01/41
      ).replace(
        /^([0]+)\/|[0]+$/g,
        "0"
        // 0/ > 0 and 00 > 0
      ).replace(
        /[^\d\/]|^[\/]*$/g,
        //eslint-disable-line
        ""
        // To allow only digits and `/`
      ).replace(
        /\/\//g,
        "/"
        // Prevent entering more than 1 `/`
      ));
    }, V = (E) => {
      var Q;
      if (_.value = E.target.value, A(""), !((Q = E == null ? void 0 : E.target) != null && Q.value)) {
        A(""), v(!0);
        return;
      }
      const w = E.target.value.split("/"), T = Number(w[0]), D = Number(w[1]), H = (/* @__PURE__ */ new Date()).getMonth() + 1, x = (/* @__PURE__ */ new Date()).getFullYear() % 100;
      !T || !D ? (A(""), v(!0)) : D < x ? (v(!0), A(M.CARD_EXPIRY_YEAR_IN_PAST)) : D > x + 50 ? (v(!0), A(M.INVALID_CARD_EXPIRY_YEAR)) : T < H && D == x ? (v(!0), A(M.CARD_EXPIRY_MONTH_IN_PAST)) : (A(""), v(!1));
    }, W = (E) => {
      var w;
      N.value = (w = E == null ? void 0 : E.target) == null ? void 0 : w.value, o.value && N.value.length < 4 || !o.value && N.value.length < 3 ? I(!0) : I(!1);
    };
    function K() {
      return X() ? (j(), !0) : !1;
    }
    async function J(E) {
      var w, T, D, H;
      try {
        n($.PAYMENT_CALLBACK, {
          type: Z.PROCESSING,
          value: !0,
          provider: q.AUTHORIZE_NET
        });
        const x = await k(), Q = N.value, { opaqueData: ne } = x || {}, G = await ee(
          ne,
          Q,
          E
        );
        return n($.PAYMENT_CALLBACK, {
          type: Z.SUCCESS,
          data: G,
          provider: q.AUTHORIZE_NET
        }), !0;
      } catch (x) {
        if (x.type === St.SERVER_ERROR)
          A((H = (D = (T = (w = x == null ? void 0 : x.response) == null ? void 0 : w.messages) == null ? void 0 : T.message) == null ? void 0 : D[0]) == null ? void 0 : H.text);
        else {
          const Q = qe(x);
          A(Q || (x == null ? void 0 : x.message) || M.SOMETHING_WENT_WRONG);
        }
        return !1;
      }
    }
    function X() {
      return f.value || p(!0), _.value || v(!0), N.value || I(!0), !(b.value || y.value || L.value);
    }
    function k() {
      var D, H, x;
      const { merchantPublicClientKey: E, merchantLoginId: w } = r, T = {
        authData: {
          clientKey: E,
          apiLoginID: w
        },
        cardData: {
          cardNumber: (D = f.value) == null ? void 0 : D.replaceAll(/\s/g, ""),
          month: (H = _.value) == null ? void 0 : H.split("/")[0],
          year: (x = _.value) == null ? void 0 : x.split("/")[1],
          cardCode: N.value
        }
      };
      return new Promise(function(Q, ne) {
        window == null || window.Accept.dispatchData(T, function(G) {
          var ye, fe, re;
          return ((fe = (ye = G == null ? void 0 : G.messages) == null ? void 0 : ye.resultCode) == null ? void 0 : fe.toUpperCase()) === "OK" ? (re = G == null ? void 0 : G.opaqueData) != null && re.dataValue ? Q(G) : ne({
            message: M.SOMETHING_WENT_WRONG_IN_GETTING_CARD_TOKEN
          }) : ne({ type: St.SERVER_ERROR, response: G });
        });
      });
    }
    async function ee(E, w, T) {
      const { source: D } = T;
      if (D === he.ORDER)
        return await se(E, w, T);
      if (D === he.INVOICE)
        return await de(E, w, T);
      throw new Error(M.INVALID_PAYMENT_SOURCE);
    }
    async function se(E, w, T) {
      const { env: D, altId: H, altType: x } = r, { sourceId: Q } = T, ne = (T == null ? void 0 : T.traceId) || r.traceId, G = `${ge[D]}/authorize-net/order/pay`, ye = {
        ...T == null ? void 0 : T.extra,
        altId: H,
        altType: x,
        orderId: Q,
        opaqueData: E,
        cardCode: w
      }, fe = {};
      ne && (fe["x-parent-trace-context"] = ne);
      const { data: re } = await ce.post(G, ye, { headers: fe });
      if (!re.success)
        throw new Error(re.message);
      return re;
    }
    async function de(E, w, T) {
      const { env: D, altId: H, altType: x } = r, { sourceId: Q } = T, ne = (T == null ? void 0 : T.traceId) || r.traceId, G = `${dt[D]}/authorize-net/payment`, ye = {
        ...T == null ? void 0 : T.extra,
        altId: H,
        altType: x,
        invoiceId: Q,
        opaqueData: E,
        cardCode: w
      }, fe = {};
      ne && (fe["x-parent-trace-context"] = ne);
      const { data: re } = await ce.post(G, ye, { headers: fe });
      if (!re.success)
        throw new Error(re.message);
      return re;
    }
    return t({
      validatePayment: K,
      confirmPayment: J
    }), (E, w) => (Y(), ae(rt, null, [
      e.showModeBadge && !i.value ? (Y(), Ne(ft, {
        key: 0,
        liveMode: e.liveMode
      }, null, 8, ["liveMode"])) : ie("", !0),
      Ft(un, null, {
        default: $t(() => [
          B("div", null, [
            si,
            B("input", {
              type: "text",
              name: "cc",
              value: f.value,
              disabled: i.value,
              id: `cc-${e.id}`,
              maxlength: h.value,
              placeholder: "1234 1234 1234 1234",
              class: Ae(["card-input", b.value ? "card-input-error" : ""]),
              onKeyup: g,
              onKeydown: R,
              onChange: P,
              onFocusout: P
            }, null, 42, ai)
          ]),
          B("div", ci, [
            B("div", null, [
              li,
              B("input", {
                type: "text",
                name: "card-expiration",
                value: _.value,
                disabled: i.value,
                id: `card-expiration-${e.id}`,
                maxlength: "5",
                placeholder: "MM / YY",
                class: Ae([
                  "card-input",
                  y.value ? "card-input-error" : ""
                ]),
                onKeydown: R,
                onChange: V,
                onKeyup: F,
                onFocusout: V
              }, null, 42, ui)
            ]),
            B("div", null, [
              di,
              B("input", {
                type: "text",
                name: "card-cvc",
                value: N.value,
                disabled: i.value,
                id: `card-cvc-${e.id}`,
                maxlength: o.value ? "4" : "3",
                placeholder: "CVC",
                class: Ae(["card-input", L.value ? "card-input-error" : ""]),
                onChange: W,
                onKeydown: R,
                onFocusout: W
              }, null, 42, fi)
            ])
          ])
        ]),
        _: 1
      })
    ], 64));
  }
});
const mi = /* @__PURE__ */ dn(hi, [["__scopeId", "data-v-b2d1e265"]]), yi = {
  key: 0,
  for: "cardNumber",
  class: "card-input-label"
}, Ei = ["id"], vi = { class: "credit-card-sub-container" }, Ni = {
  key: 0,
  for: "cardExpiration",
  class: "card-input-label"
}, gi = ["id"], wi = {
  key: 0,
  for: "cardExpiration",
  class: "card-input-label"
}, Oi = ["id"], _i = {
  name: "UINMICardElement",
  inheritAttrs: !1
}, bi = /* @__PURE__ */ Oe({
  ..._i,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    merchantPublicKey: {
      type: String,
      required: !0
    }
  },
  emits: [$.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = C(!0), o = C(!1), s = C(), c = C({}), u = (h) => {
      n($.PAYMENT_CALLBACK, {
        type: Z.ERROR,
        message: h,
        provider: q.NMI
      });
    };
    Se(() => l());
    async function l() {
      const { id: h, liveMode: p, merchantPublicKey: v } = r;
      if (window != null && window.CollectJS)
        await d(h);
      else {
        const I = p ? ve == null ? void 0 : ve[z.PRODUCTION] : ve == null ? void 0 : ve[z.SANDBOX];
        i.value = !0;
        const A = await an(
          "collect-js",
          I,
          q.NMI,
          v
        );
        A.onload = async () => {
          await d(h);
        };
      }
    }
    const d = async (h) => {
      var v;
      const p = $r(h);
      await ((v = window == null ? void 0 : window.CollectJS) == null ? void 0 : v.configure({
        ...p,
        validationCallback: function(I, A) {
          s.value = {
            ...s.value,
            [I]: A
          }, Object.values(s.value).includes(!1) ? o.value = !1 : Object.values(s.value).length === 3 && (o.value = !0);
        },
        timeoutCallback: function() {
          u(M.NMI_SDK_LOAD_ERROR);
        },
        fieldsAvailableCallback: function() {
          n($.PAYMENT_CALLBACK, {
            type: Z.READY,
            value: !0,
            provider: q.NMI
          }), i.value = !1;
        },
        callback: (I) => {
          _(I.token);
        }
      }));
    };
    function f() {
      return o.value ? (u(""), !0) : (u(M.INVALID_CARD_DETAILS), !1);
    }
    async function b(h) {
      var p;
      try {
        n($.PAYMENT_CALLBACK, {
          type: Z.PROCESSING,
          value: !0,
          provider: q.NMI
        }), c.value = h, (p = window == null ? void 0 : window.CollectJS) == null || p.startPaymentRequest();
      } catch (v) {
        return u(v.message || M.SOMETHING_WENT_WRONG), !1;
      }
    }
    async function _(h) {
      try {
        const p = await y(h, c.value);
        return n($.PAYMENT_CALLBACK, {
          type: Z.SUCCESS,
          data: p,
          provider: q.NMI
        }), !0;
      } catch (p) {
        const v = qe(p);
        return u(
          v || p.message || M.SOMETHING_WENT_WRONG_IN_INITIATE_PAYMENT
        ), !1;
      }
    }
    async function y(h, p) {
      const { source: v } = p;
      if (v === he.ORDER)
        return await await N(h, p);
      if (v === he.INVOICE)
        return await L(h, p);
      throw new Error(M.INVALID_PAYMENT_SOURCE);
    }
    async function N(h, p) {
      const { env: v, altId: I, altType: A } = r, { sourceId: j } = p, m = (p == null ? void 0 : p.traceId) || r.traceId, g = `${ge[v]}/nmi/order/pay`, O = {
        ...p == null ? void 0 : p.extra,
        altId: I,
        altType: A,
        orderId: j,
        paymentToken: h
      }, P = {};
      m && (P["x-parent-trace-context"] = m);
      const { data: R } = await ce.post(g, O, { headers: P });
      if (!R.success)
        throw new Error(R.message);
      return R;
    }
    async function L(h, p) {
      const { env: v, altId: I, altType: A } = r, { sourceId: j } = p, m = (p == null ? void 0 : p.traceId) || r.traceId, g = `${dt[v]}/nmi/payment`, O = {
        ...p == null ? void 0 : p.extra,
        altId: I,
        altType: A,
        invoiceId: j,
        paymentToken: h
      }, P = {};
      m && (P["x-parent-trace-context"] = m);
      const { data: R } = await ce.post(g, O, { headers: P });
      if (!R.success)
        throw new Error(R.message);
      return R;
    }
    return t({
      validatePayment: f,
      confirmPayment: b
    }), (h, p) => (Y(), ae(rt, null, [
      e.showModeBadge && !i.value ? (Y(), Ne(ft, {
        key: 0,
        liveMode: e.liveMode
      }, null, 8, ["liveMode"])) : ie("", !0),
      Ft(un, null, {
        default: $t(() => [
          B("div", null, [
            i.value ? ie("", !0) : (Y(), ae("label", yi, "Card Number")),
            B("div", {
              id: `ccnumber-${e.id}`
            }, null, 8, Ei)
          ]),
          B("div", vi, [
            B("div", null, [
              i.value ? ie("", !0) : (Y(), ae("label", Ni, "Expiration")),
              B("div", {
                id: `ccexp-${e.id}`
              }, null, 8, gi)
            ]),
            B("div", null, [
              i.value ? ie("", !0) : (Y(), ae("label", wi, "CVC")),
              B("div", {
                id: `cvv-${e.id}`
              }, null, 8, Oi)
            ])
          ])
        ]),
        _: 1
      })
    ], 64));
  }
});
var tt = {}, Ii = {
  get exports() {
    return tt;
  },
  set exports(e) {
    tt = e;
  }
}, ht = {};
Object.defineProperty(ht, "__esModule", { value: !0 });
function Be(e) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Be = function(t) {
    return typeof t;
  } : Be = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Be(e);
}
var fn = "https://js.stripe.com/v3", Si = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/, Dt = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used", Ri = function() {
  for (var t = document.querySelectorAll('script[src^="'.concat(fn, '"]')), n = 0; n < t.length; n++) {
    var r = t[n];
    if (Si.test(r.src))
      return r;
  }
  return null;
}, Ti = function(t) {
  var n = t && !t.advancedFraudSignals ? "?advancedFraudSignals=false" : "", r = document.createElement("script");
  r.src = "".concat(fn).concat(n);
  var i = document.head || document.body;
  if (!i)
    throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
  return i.appendChild(r), r;
}, Ci = function(t, n) {
  !t || !t._registerWrapper || t._registerWrapper({
    name: "stripe-js",
    version: "1.50.0",
    startTime: n
  });
}, Ce = null, Ai = function(t) {
  return Ce !== null || (Ce = new Promise(function(n, r) {
    if (typeof window > "u" || typeof document > "u") {
      n(null);
      return;
    }
    if (window.Stripe && t && console.warn(Dt), window.Stripe) {
      n(window.Stripe);
      return;
    }
    try {
      var i = Ri();
      i && t ? console.warn(Dt) : i || (i = Ti(t)), i.addEventListener("load", function() {
        window.Stripe ? n(window.Stripe) : r(new Error("Stripe.js not available"));
      }), i.addEventListener("error", function() {
        r(new Error("Failed to load Stripe.js"));
      });
    } catch (o) {
      r(o);
      return;
    }
  })), Ce;
}, Pi = function(t, n, r) {
  if (t === null)
    return null;
  var i = t.apply(void 0, n);
  return Ci(i, r), i;
}, Lt = function(t) {
  var n = `invalid load parameters; expected object of shape

    {advancedFraudSignals: boolean}

but received

    `.concat(JSON.stringify(t), `
`);
  if (t === null || Be(t) !== "object")
    throw new Error(n);
  if (Object.keys(t).length === 1 && typeof t.advancedFraudSignals == "boolean")
    return t;
  throw new Error(n);
}, Ue, nt = !1, pn = function() {
  for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
    n[r] = arguments[r];
  nt = !0;
  var i = Date.now();
  return Ai(Ue).then(function(o) {
    return Pi(o, n, i);
  });
};
pn.setLoadParameters = function(e) {
  if (nt && Ue) {
    var t = Lt(e), n = Object.keys(t), r = n.reduce(function(i, o) {
      var s;
      return i && e[o] === ((s = Ue) === null || s === void 0 ? void 0 : s[o]);
    }, !0);
    if (r)
      return;
  }
  if (nt)
    throw new Error("You cannot change load parameters after calling loadStripe");
  Ue = Lt(e);
};
ht.loadStripe = pn;
(function(e) {
  e.exports = ht;
})(Ii);
/*!
 * currency.js - v2.0.4
 * http://scurker.github.io/currency.js
 *
 * Copyright (c) 2021 Jason Wilson
 * Released under MIT license
 */
var Mi = {
  symbol: "$",
  separator: ",",
  decimal: ".",
  errorOnInvalid: !1,
  precision: 2,
  pattern: "!#",
  negativePattern: "-!#",
  format: Bi,
  fromCents: !1
}, hn = function(t) {
  return Math.round(t);
}, mt = function(t) {
  return Math.pow(10, t);
}, xi = function(t, n) {
  return hn(t / n) * n;
}, Di = /(\d)(?=(\d{3})+\b)/g, Li = /(\d)(?=(\d\d)+\d\b)/g;
function te(e, t) {
  var n = this;
  if (!(n instanceof te))
    return new te(e, t);
  var r = Object.assign({}, Mi, t), i = mt(r.precision), o = Fe(e, r);
  n.intValue = o, n.value = o / i, r.increment = r.increment || 1 / i, r.useVedic ? r.groups = Li : r.groups = Di, this.s = r, this.p = i;
}
function Fe(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, r = 0, i = t.decimal, o = t.errorOnInvalid, s = t.precision, c = t.fromCents, u = mt(s), l = typeof e == "number", d = e instanceof te;
  if (d && c)
    return e.intValue;
  if (l || d)
    r = d ? e.value : e;
  else if (typeof e == "string") {
    var f = new RegExp("[^-\\d" + i + "]", "g"), b = new RegExp("\\" + i, "g");
    r = e.replace(/\((.*)\)/, "-$1").replace(f, "").replace(b, "."), r = r || 0;
  } else {
    if (o)
      throw Error("Invalid Input");
    r = 0;
  }
  return c || (r *= u, r = r.toFixed(4)), n ? hn(r) : r;
}
function Bi(e, t) {
  var n = t.pattern, r = t.negativePattern, i = t.symbol, o = t.separator, s = t.decimal, c = t.groups, u = ("" + e).replace(/^-/, "").split("."), l = u[0], d = u[1];
  return (e.value >= 0 ? n : r).replace("!", i).replace("#", l.replace(c, "$1" + o) + (d ? s + d : ""));
}
te.prototype = {
  /**
   * Adds values together.
   * @param {number} number
   * @returns {currency}
   */
  add: function(t) {
    var n = this.intValue, r = this.s, i = this.p;
    return te((n += Fe(t, r)) / (r.fromCents ? 1 : i), r);
  },
  /**
   * Subtracts value.
   * @param {number} number
   * @returns {currency}
   */
  subtract: function(t) {
    var n = this.intValue, r = this.s, i = this.p;
    return te((n -= Fe(t, r)) / (r.fromCents ? 1 : i), r);
  },
  /**
   * Multiplies values.
   * @param {number} number
   * @returns {currency}
   */
  multiply: function(t) {
    var n = this.intValue, r = this.s;
    return te((n *= t) / (r.fromCents ? 1 : mt(r.precision)), r);
  },
  /**
   * Divides value.
   * @param {number} number
   * @returns {currency}
   */
  divide: function(t) {
    var n = this.intValue, r = this.s;
    return te(n /= Fe(t, r, !1), r);
  },
  /**
   * Takes the currency amount and distributes the values evenly. Any extra pennies
   * left over from the distribution will be stacked onto the first set of entries.
   * @param {number} count
   * @returns {array}
   */
  distribute: function(t) {
    for (var n = this.intValue, r = this.p, i = this.s, o = [], s = Math[n >= 0 ? "floor" : "ceil"](n / t), c = Math.abs(n - s * t), u = i.fromCents ? 1 : r; t !== 0; t--) {
      var l = te(s / u, i);
      c-- > 0 && (l = l[n >= 0 ? "add" : "subtract"](1 / u)), o.push(l);
    }
    return o;
  },
  /**
   * Returns the dollar value.
   * @returns {number}
   */
  dollars: function() {
    return ~~this.value;
  },
  /**
   * Returns the cent value.
   * @returns {number}
   */
  cents: function() {
    var t = this.intValue, n = this.p;
    return ~~(t % n);
  },
  /**
   * Formats the value as a string according to the formatting settings.
   * @param {boolean} useSymbol - format with currency symbol
   * @returns {string}
   */
  format: function(t) {
    var n = this.s;
    return typeof t == "function" ? t(this, n) : n.format(this, Object.assign({}, n, t));
  },
  /**
   * Formats the value as a string according to the formatting settings.
   * @returns {string}
   */
  toString: function() {
    var t = this.intValue, n = this.p, r = this.s;
    return xi(t / n, r.increment).toFixed(r.precision);
  },
  /**
   * Value for JSON serialization.
   * @returns {float}
   */
  toJSON: function() {
    return this.value;
  }
};
const Ui = ["id"], Fi = {
  name: "UIStripePaymentElement",
  inheritAttrs: !1
}, $i = /* @__PURE__ */ Oe({
  ...Fi,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    publishableKey: {
      type: String,
      required: !0
    },
    accountId: {
      type: String,
      required: !0
    },
    stripeOptions: {
      type: Object,
      required: !0
    },
    stripeMinimumChargeAmount: {
      type: Object,
      required: !0
    },
    stripeZeroDecimalCurrencies: {
      type: Object,
      required: !0
    }
  },
  emits: [$.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = (m, g) => {
      var O;
      return (O = r.stripeZeroDecimalCurrencies) != null && O.includes(g == null ? void 0 : g.toUpperCase()) ? te(m, { precision: 0 }).value : te(m).multiply(100).value;
    }, o = C(), s = C(), c = C(), u = (m) => {
      n($.PAYMENT_CALLBACK, {
        type: Z.ERROR,
        message: m,
        provider: q.STRIPE
      });
    };
    Se(() => l());
    async function l() {
      if (await d(), !o.value)
        return;
      const m = f();
      await b(m);
    }
    async function d() {
      const { publishableKey: m, accountId: g } = r, O = await tt.loadStripe(m, { stripeAccount: g });
      if (!O) {
        u(M.STRIPE_SDK_LOAD_ERROR);
        return;
      }
      return o.value = O, O;
    }
    function f() {
      const { mode: m, currency: g, paymentMethodConfiguration: O, paymentMethodOptions: P } = r.stripeOptions;
      let { amount: R } = r.stripeOptions, F = "automatic";
      return R === 0 && (F = "manual", R = 1, r.stripeMinimumChargeAmount && (R = r.stripeMinimumChargeAmount[g == null ? void 0 : g.toUpperCase()] || 1)), {
        mode: m,
        amount: i(R, g),
        currency: g,
        setupFutureUsage: "off_session",
        captureMethod: F,
        payment_method_configuration: O,
        payment_method_options: P
      };
    }
    async function b(m) {
      var P, R, F;
      const g = o.value.elements(m);
      s.value = g;
      let O = {
        applePay: "never",
        auBecsDebit: "never",
        bancontact: "never",
        card: "never",
        cashapp: "never",
        googlePay: "never",
        ideal: "never",
        paypal: "never",
        sepaDebit: "never",
        sofort: "never",
        usBankAccount: "never"
      };
      if ((P = r.stripeOptions) != null && P.terms && (O = (R = r.stripeOptions) == null ? void 0 : R.terms), c.value = g.create("payment", {
        layout: (F = r.stripeOptions) == null ? void 0 : F.layout,
        terms: O
      }), !c.value) {
        u(M.STRIPE_PAYMENT_ELEMENT_CREATE_ERROR);
        return;
      }
      c.value.mount(`#${r.id}`), c.value.on("ready", function() {
        n($.PAYMENT_CALLBACK, {
          type: Z.READY,
          value: !0,
          provider: q.STRIPE
        });
      }), c.value.on("loaderror", function(V) {
        console.log("Stripe Payment Element Load Error", V), u(M.STRIPE_PAYMENT_ELEMENT_LOAD_ERROR);
      });
    }
    Ve(r.stripeOptions, () => {
      const m = f();
      if (r.debug && console.log("Stripe Payment Element Options", m), !s.value)
        return b(m);
      s.value.update(m);
    });
    async function _() {
      const { error: m } = await s.value.submit();
      return m ? (u(m == null ? void 0 : m.message), !1) : (u(""), !0);
    }
    async function y(m) {
      try {
        n($.PAYMENT_CALLBACK, {
          type: Z.PROCESSING,
          value: !0,
          provider: q.STRIPE
        });
        const g = await L(m), { clientSecret: O } = g;
        if (!await N(O))
          return !1;
        const R = await v(m, g);
        return n($.PAYMENT_CALLBACK, {
          type: Z.SUCCESS,
          data: R,
          provider: q.STRIPE
        }), !0;
      } catch (g) {
        const O = qe(g);
        return u(
          O || g.message || M.SOMETHING_WENT_WRONG_IN_CONFIRMING_PAYMENT
        ), !1;
      }
    }
    async function N(m) {
      var O;
      const g = await o.value.confirmPayment({
        elements: s.value,
        clientSecret: m,
        redirect: "if_required",
        confirmParams: {
          return_url: window.location.href
        }
      });
      return g.error ? g.error.type === Fr.VALIDATION_ERROR ? (u(""), !1) : (u(
        ((O = g.error) == null ? void 0 : O.message) || M.FAILED_TO_CONFIRM_PAYMENT
      ), !1) : !0;
    }
    async function L(m) {
      try {
        const { source: g } = m;
        let O;
        if (g === he.ORDER)
          O = await h(m);
        else if (g === he.INVOICE)
          O = await p(m);
        else
          throw new Error(M.INVALID_PAYMENT_SOURCE);
        if (!O.success)
          throw new Error(O.message);
        return O;
      } catch (g) {
        const O = qe(g);
        throw new Error(
          O || g.message || M.SOMETHING_WENT_WRONG_IN_INITIATE_PAYMENT
        );
      }
    }
    async function h(m) {
      const { env: g, altId: O, altType: P, stripeOptions: R } = r, { paymentMethodConfiguration: F, paymentMethodOptions: V } = R, { sourceId: W, captchaToken: K } = m, J = (m == null ? void 0 : m.traceId) || r.traceId, X = `${ge[g]}/stripe/initiate`, k = {
        altId: O,
        altType: P,
        orderId: W,
        paymentMethodConfiguration: F,
        paymentMethodOptions: V,
        captchaToken: K
      }, ee = {};
      J && (ee["x-parent-trace-context"] = J);
      const { data: se } = await ce.post(X, k, { headers: ee });
      return se;
    }
    async function p(m) {
      const { env: g, altId: O, altType: P, stripeOptions: R } = r, { paymentMethodConfiguration: F, paymentMethodOptions: V } = R, { sourceId: W } = m, K = (m == null ? void 0 : m.traceId) || (r == null ? void 0 : r.traceId), J = `${ge[g]}/stripe/invoice/initiate`, X = {
        altId: O,
        altType: P,
        invoiceId: W,
        paymentMethodConfiguration: F,
        paymentMethodOptions: V
      }, k = {};
      K && (k["x-parent-trace-context"] = K);
      const { data: ee } = await ce.post(J, X, { headers: k });
      return ee;
    }
    async function v(m, g) {
      const { source: O } = m;
      if (O === he.ORDER)
        return await I(m, g);
      if (O === he.INVOICE)
        return await A(m, g);
      throw new Error(M.INVALID_PAYMENT_SOURCE);
    }
    async function I(m, g) {
      const { env: O, altId: P, altType: R } = r, { sourceId: F } = m, V = `${ge[O]}/stripe/verify`, { subscriptionId: W, invoiceId: K, paymentIntentId: J, isAuth: X, traceId: k } = g, ee = {
        ...m == null ? void 0 : m.extra,
        altId: P,
        altType: R,
        orderId: F,
        subscriptionId: W,
        invoiceId: K,
        paymentIntentId: J,
        isAuth: X
      }, se = {};
      k && (se["x-parent-trace-context"] = k);
      const { data: de } = await ce.post(V, ee, { headers: se });
      if (!de.success)
        throw new Error(de.message);
      return de;
    }
    async function A(m, g) {
      const { env: O, altId: P, altType: R } = r, { sourceId: F } = m, V = `${dt[O]}/verify-payment`, { txnId: W, traceId: K } = g, J = {
        ...m == null ? void 0 : m.extra,
        altId: P,
        altType: R,
        invoiceId: F,
        internalTxnId: W
      }, X = {};
      K && (X["x-parent-trace-context"] = K);
      const { data: k } = await ce.post(V, J, { headers: X });
      if (!k.success)
        throw new Error(k.message);
      return k;
    }
    On(() => j());
    function j() {
      c.value && c.value.destroy();
    }
    return t({
      validatePayment: _,
      confirmPayment: y
    }), (m, g) => (Y(), ae(rt, null, [
      e.showModeBadge && c.value ? (Y(), Ne(ft, {
        key: 0,
        liveMode: e.liveMode
      }, null, 8, ["liveMode"])) : ie("", !0),
      _n(B("div", { id: e.id }, null, 8, Ui), [
        [bn, c.value]
      ])
    ], 64));
  }
}), qi = { class: "ghl-payment-element" }, Vi = {
  name: "UIPaymentElement",
  inheritAttrs: !1
}, ki = /* @__PURE__ */ Oe({
  ...Vi,
  props: {
    env: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    altId: {
      type: String,
      required: !0
    },
    altType: {
      type: String,
      required: !0
    },
    liveMode: {
      type: Boolean,
      required: !0
    },
    showModeBadge: {
      type: Boolean,
      required: !1,
      default: !0
    },
    debug: {
      type: Boolean,
      required: !1,
      default: !1
    },
    traceId: {
      type: String,
      required: !1
    },
    stripeOptions: {
      type: Object,
      required: !1
    }
  },
  emits: [$.PAYMENT_CALLBACK],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = C(), o = C(), s = C(), c = C();
    function u(h) {
      n($.PAYMENT_CALLBACK, {
        type: Z.ERROR,
        message: h
      });
    }
    Se(async () => {
      const h = await l();
      h && d(h);
    });
    async function l() {
      const { env: h, liveMode: p, altId: v, altType: I, traceId: A } = r;
      if (!(![!0, !1].includes(p) || !v || !I))
        try {
          const j = {};
          A && (j["x-parent-trace-context"] = A);
          const { data: m } = await ce.get(
            `${ge[h]}/integrations/public`,
            {
              params: {
                altId: v,
                altType: I,
                liveMode: p
              },
              headers: j
            }
          );
          return m;
        } catch (j) {
          u(
            j.message || M.SOMETHING_WENT_WRONG_IN_FETCHING_PAYMENT_INTEGRATIONS
          );
        }
    }
    function d(h) {
      const { defaultPaymentProvider: p } = h;
      if (!p)
        return u(M.PAYMENT_PROVIDER_NOT_FOUND);
      p === q.STRIPE ? f(h.stripe) : p === q.NMI ? b(h.nmi) : p === q.AUTHORIZE_NET && _(h.authorizeNet);
    }
    function f(h) {
      const {
        publishableKey: p,
        accountId: v,
        stripeMinimumChargeAmount: I,
        stripeZeroDecimalCurrencies: A
      } = h;
      if (!p || !v)
        return u(M.STRIPE_CONNECTION_NOT_FOUND);
      i.value = {
        stripe: {
          show: !0,
          publishableKey: p,
          accountId: v,
          stripeMinimumChargeAmount: I,
          stripeZeroDecimalCurrencies: A
        }
      };
    }
    function b(h) {
      const { merchantPublicKey: p } = h;
      if (!p)
        return u(M.NMI_CONNECTION_NOT_FOUND);
      i.value = {
        nmi: {
          show: !0,
          merchantPublicKey: p
        }
      };
    }
    function _(h) {
      const { merchantLoginId: p, merchantPublicClientKey: v } = h;
      if (!p || !v)
        return u(M.AUTHORIZE_NET_CONNECTION_NOT_FOUND);
      i.value = {
        authorizeNet: {
          show: !0,
          merchantLoginId: p,
          merchantPublicClientKey: v
        }
      };
    }
    function y(h) {
      n($.PAYMENT_CALLBACK, h);
    }
    async function N() {
      const { stripe: h, nmi: p, authorizeNet: v } = i.value || {};
      return h != null && h.show ? await o.value.validatePayment() : p != null && p.show ? await s.value.validatePayment() : v != null && v.show ? await c.value.validatePayment() : (u(M.PAYMENT_PROVIDER_NOT_FOUND), !1);
    }
    async function L(h) {
      const { stripe: p, nmi: v, authorizeNet: I } = i.value || {};
      return p != null && p.show ? await o.value.confirmPayment(h) : v != null && v.show ? await s.value.confirmPayment(h) : I != null && I.show ? await c.value.confirmPayment(h) : (u(M.PAYMENT_PROVIDER_NOT_FOUND), !1);
    }
    return t({
      validatePayment: N,
      confirmPayment: L
    }), (h, p) => {
      var v, I, A, j, m, g, O, P, R, F, V, W, K, J, X, k, ee, se, de, E;
      return Y(), ae("div", qi, [
        e.stripeOptions && ((I = (v = i.value) == null ? void 0 : v.stripe) != null && I.show) ? (Y(), Ne($i, {
          key: 0,
          ref_key: "stripePaymentElement",
          ref: o,
          env: e.env,
          id: e.id,
          altId: e.altId,
          altType: e.altType,
          liveMode: e.liveMode,
          showModeBadge: e.showModeBadge,
          debug: e.debug,
          publishableKey: (j = (A = i.value) == null ? void 0 : A.stripe) == null ? void 0 : j.publishableKey,
          accountId: (g = (m = i.value) == null ? void 0 : m.stripe) == null ? void 0 : g.accountId,
          stripeOptions: e.stripeOptions,
          onPaymentCallback: y,
          stripeMinimumChargeAmount: (P = (O = i.value) == null ? void 0 : O.stripe) == null ? void 0 : P.stripeMinimumChargeAmount,
          stripeZeroDecimalCurrencies: (F = (R = i.value) == null ? void 0 : R.stripe) == null ? void 0 : F.stripeZeroDecimalCurrencies
        }, null, 8, ["env", "id", "altId", "altType", "liveMode", "showModeBadge", "debug", "publishableKey", "accountId", "stripeOptions", "stripeMinimumChargeAmount", "stripeZeroDecimalCurrencies"])) : ie("", !0),
        (W = (V = i.value) == null ? void 0 : V.nmi) != null && W.show ? (Y(), Ne(bi, {
          key: 1,
          ref_key: "nmiCardElement",
          ref: s,
          env: e.env,
          id: e.id,
          altId: e.altId,
          altType: e.altType,
          liveMode: e.liveMode,
          showModeBadge: e.showModeBadge,
          debug: e.debug,
          merchantPublicKey: (J = (K = i.value) == null ? void 0 : K.nmi) == null ? void 0 : J.merchantPublicKey,
          onPaymentCallback: y
        }, null, 8, ["env", "id", "altId", "altType", "liveMode", "showModeBadge", "debug", "merchantPublicKey"])) : ie("", !0),
        (k = (X = i.value) == null ? void 0 : X.authorizeNet) != null && k.show ? (Y(), Ne(mi, {
          key: 2,
          ref_key: "authorizeNetCardElement",
          ref: c,
          env: e.env,
          id: e.id,
          altId: e.altId,
          altType: e.altType,
          liveMode: e.liveMode,
          showModeBadge: e.showModeBadge,
          debug: e.debug,
          merchantLoginId: (se = (ee = i.value) == null ? void 0 : ee.authorizeNet) == null ? void 0 : se.merchantLoginId,
          merchantPublicClientKey: (E = (de = i.value) == null ? void 0 : de.authorizeNet) == null ? void 0 : E.merchantPublicClientKey,
          onPaymentCallback: y
        }, null, 8, ["env", "id", "altId", "altType", "liveMode", "showModeBadge", "debug", "merchantLoginId", "merchantPublicClientKey"])) : ie("", !0)
      ]);
    };
  }
}), Je = {
  UIPaymentElement: ki
};
function ji(e) {
  for (const t in Je)
    e.component(Je[t].name, Je[t]);
}
const Ki = { install: ji };
export {
  ki as UIPaymentElement,
  Ki as default
};
